var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoRestReTurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18V16.6667H16.8V18H6ZM16.8 9.33333V7.33333H15.6V9.33333H16.8ZM16.8 6C17.1183 6 17.4235 6.14048 17.6485 6.39052C17.8736 6.64057 18 6.97971 18 7.33333V9.33333C18 9.68696 17.8736 10.0261 17.6485 10.2761C17.4235 10.5262 17.1183 10.6667 16.8 10.6667H15.6V12.6667C15.6 13.3739 15.3471 14.0522 14.8971 14.5523C14.447 15.0524 13.8365 15.3333 13.2 15.3333H9.6C8.96348 15.3333 8.35303 15.0524 7.90294 14.5523C7.45286 14.0522 7.2 13.3739 7.2 12.6667V6H16.8ZM14.4 7.33333H8.4V12.6667C8.4 13.0203 8.52643 13.3594 8.75147 13.6095C8.97652 13.8595 9.28174 14 9.6 14H13.2C13.5183 14 13.8235 13.8595 14.0485 13.6095C14.2736 13.3594 14.4 13.0203 14.4 12.6667V7.33333Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoRestReTurn);
export default __webpack_public_path__ + "static/media/GoRestReTurn.bfbf3107772dd01ff72265d743c3f464.svg";
export { ForwardRef as ReactComponent };